/**
 * Default storefront product sort orders (EN-56).
 *
 * Products are grouped first (by brand, or by category on a brand's own page) and then ordered
 * inside that group by the curated ProductDisplayOrder set in the admin portal's Product Order
 * screen, falling back to name for anything not yet arranged. The view coalesces an unset
 * DisplayOrder to int.MaxValue, so unarranged products sort last rather than first.
 *
 * These live in one place because each page uses its default three times — as the initial sort,
 * as the "is this still the default?" test that keeps `?sort=` out of the URL, and as the
 * dropdown's Default item. Three copies per page drift; one constant can't.
 */

/** Grouped by brand — the all-products and category listings. */
export const DEFAULT_PRODUCT_SORT = 'brandDisplayOrder, productDisplayOrder, productName';

/** Grouped by category — a single brand's page, where every product shares the brand. */
export const BRAND_PAGE_PRODUCT_SORT = 'productSectionDisplayOrder, productDisplayOrder, productName';
